// City data structure for local SEO landing pages
// Covers top 20 Indian cities with comprehensive data for each city page

// City data with all required fields for SEO optimization
export const cityData = {
  mumbai: {
    name: "Mumbai",
    state: "Maharashtra",
    slug: "restaurant-billing-software-mumbai",
    title: "Best KOT-First Restaurant Automation Platform Mumbai 2025 | BillByteKOT",
    description: "Top KOT-first restaurant automation platform for Mumbai restaurants. KOT system, GST billing, WhatsApp integration. Trusted by 150+ Mumbai restaurants. Starting ₹1999/year.",
    keywords: [
      "KOT-first restaurant automation platform Mumbai",
      "restaurant automation Mumbai",
      "restaurant POS Mumbai",
      "restaurant automation software Mumbai restaurants",
      "Mumbai restaurant software",
      "POS system Mumbai"
    ],
    stats: {
      restaurantCount: 150,
      averageRating: 4.9,
      topCuisines: ["Indian", "Chinese", "Continental", "Street Food", "Seafood"],
      averageSavings: "₹10,000"
    },
    testimonials: [
      {
        name: "Rajesh Sharma",
        restaurant: "Spice Garden, Andheri",
        quote: "BillByteKOT transformed our restaurant operations! The KOT system reduced kitchen errors by 80% and the thermal printing is fantastic.",
        rating: 5,
        image: "/images/testimonials/rajesh-mumbai.jpg"
      },
      {
        name: "Priya Patel",
        restaurant: "Coastal Delights, Bandra",
        quote: "Switched from Petpooja to BillByteKOT and saved ₹12,000 annually. The WhatsApp integration boosted our customer engagement significantly.",
        rating: 5,
        image: "/images/testimonials/priya-mumbai.jpg"
      },
      {
        name: "Amit Joshi",
        restaurant: "Mumbai Tadka, Powai",
        quote: "Best decision for our restaurant! The offline mode works perfectly during monsoons when internet is unstable.",
        rating: 5,
        image: "/images/testimonials/amit-mumbai.jpg"
      }
    ],
    localFeatures: [
      "GST compliant for Maharashtra state regulations",
      "Multi-language support (Marathi, Hindi, English)",
      "Local payment gateway integrations (Paytm, PhonePe, GPay)",
      "Monsoon-ready offline mode for connectivity issues",
      "Support for Mumbai's diverse cuisine types",
      "Integration with local delivery partners (Zomato, Swiggy)",
      "24/7 local customer support in Mumbai timezone"
    ],
    nearbyAreas: [
      "Andheri", "Bandra", "Powai", "Thane", "Navi Mumbai", 
      "Borivali", "Malad", "Goregaon", "Juhu", "Worli"
    ],
    popularRestaurantTypes: [
      "Street Food Stalls", "Fine Dining", "Seafood Restaurants", 
      "Vada Pav Centers", "Irani Cafes", "South Indian Restaurants"
    ]
  },

  delhi: {
    name: "Delhi",
    state: "Delhi NCR",
    slug: "restaurant-billing-software-delhi",
    title: "KOT-First Restaurant Automation Platform Delhi NCR 2025 | Best POS System",
    description: "Leading KOT-first restaurant automation platform for Delhi NCR. Multi-location support, cloud sync, GST compliant. Trusted by 200+ Delhi restaurants. Free demo available.",
    keywords: [
      "KOT-first restaurant automation platform Delhi",
      "restaurant automation Delhi NCR",
      "restaurant POS Delhi NCR",
      "restaurant automation software Delhi restaurants",
      "Delhi restaurant software",
      "POS system Delhi"
    ],
    stats: {
      restaurantCount: 200,
      averageRating: 4.8,
      topCuisines: ["North Indian", "Mughlai", "Chinese", "Continental", "Street Food"],
      averageSavings: "₹11,000"
    },
    testimonials: [
      {
        name: "Vikram Singh",
        restaurant: "Delhi Darbar, CP",
        quote: "Managing 3 outlets across Delhi became effortless with BillByteKOT's multi-location features. Real-time sync keeps everything organized.",
        rating: 5,
        image: "/images/testimonials/vikram-delhi.jpg"
      },
      {
        name: "Sunita Gupta",
        restaurant: "Paranthe Wali Gali",
        quote: "Traditional business, modern technology! BillByteKOT helped us digitize without losing our authentic charm.",
        rating: 5,
        image: "/images/testimonials/sunita-delhi.jpg"
      },
      {
        name: "Rohit Malhotra",
        restaurant: "Capital Kitchen, Gurgaon",
        quote: "The GST compliance features saved us hours during tax filing. Customer support is excellent!",
        rating: 5,
        image: "/images/testimonials/rohit-delhi.jpg"
      }
    ],
    localFeatures: [
      "Multi-location management for Delhi NCR chains",
      "Hindi and English language support",
      "Integration with Delhi Metro payment systems",
      "Support for traditional Delhi cuisine billing",
      "Compliance with Delhi state GST regulations",
      "Integration with NCR delivery networks",
      "Extended support hours for Delhi business timings"
    ],
    nearbyAreas: [
      "Connaught Place", "Karol Bagh", "Lajpat Nagar", "Gurgaon", "Noida",
      "Faridabad", "Ghaziabad", "Dwarka", "Rohini", "Janakpuri"
    ],
    popularRestaurantTypes: [
      "Dhaba Style", "Fine Dining", "Street Food", "Sweet Shops",
      "Mughlai Restaurants", "Punjabi Dhabas", "Chat Centers"
    ]
  },

  bangalore: {
    name: "Bangalore",
    state: "Karnataka",
    slug: "restaurant-billing-software-bangalore",
    title: "Restaurant Billing Software Bangalore 2025 | Tech-Forward POS",
    description: "Modern restaurant billing software for Bangalore. Cloud-based, mobile-friendly, AI-powered analytics. Perfect for tech-savvy Bangalore restaurants. Try free today.",
    keywords: [
      "restaurant billing software Bangalore",
      "restaurant POS Bangalore",
      "billing software Bengaluru",
      "Bangalore restaurant software",
      "POS system Bangalore"
    ],
    stats: {
      restaurantCount: 180,
      averageRating: 4.9,
      topCuisines: ["South Indian", "North Indian", "Continental", "Chinese", "Pub Food"],
      averageSavings: "₹12,000"
    },
    testimonials: [
      {
        name: "Arjun Reddy",
        restaurant: "Tech Park Cafe, Whitefield",
        quote: "As a tech professional turned restaurateur, I appreciate BillByteKOT's modern architecture and API integrations.",
        rating: 5,
        image: "/images/testimonials/arjun-bangalore.jpg"
      },
      {
        name: "Lakshmi Rao",
        restaurant: "South Spice, Koramangala",
        quote: "The analytics dashboard helps us understand customer preferences better. Revenue increased by 25% in 6 months!",
        rating: 5,
        image: "/images/testimonials/lakshmi-bangalore.jpg"
      },
      {
        name: "Karthik Nair",
        restaurant: "Brew & Bite, Indiranagar",
        quote: "Perfect for our pub-restaurant combo. Handles both food and beverage inventory seamlessly.",
        rating: 5,
        image: "/images/testimonials/karthik-bangalore.jpg"
      }
    ],
    localFeatures: [
      "Advanced analytics for tech-savvy owners",
      "Kannada, English, and Hindi language support",
      "Integration with Bangalore's tech ecosystem",
      "Support for pub and brewery billing",
      "Karnataka state GST compliance",
      "API integrations for custom solutions",
      "Cloud-first architecture for reliability"
    ],
    nearbyAreas: [
      "Koramangala", "Indiranagar", "Whitefield", "Electronic City", "HSR Layout",
      "BTM Layout", "Jayanagar", "Malleshwaram", "Rajajinagar", "Hebbal"
    ],
    popularRestaurantTypes: [
      "Tech Park Cafeterias", "Microbreweries", "South Indian Restaurants",
      "Continental Cafes", "Pub Restaurants", "Cloud Kitchens"
    ]
  },

  hyderabad: {
    name: "Hyderabad",
    state: "Telangana",
    slug: "restaurant-billing-software-hyderabad",
    title: "Restaurant Software Hyderabad 2025 | Biryani Capital POS",
    description: "Best restaurant software for Hyderabad. Telugu interface, biryani-specific features, GST compliant. Trusted by Hyderabad's finest restaurants.",
    keywords: [
      "restaurant software Hyderabad",
      "restaurant POS Hyderabad",
      "billing software Hyderabad",
      "Hyderabad restaurant billing",
      "POS system Telangana"
    ],
    stats: {
      restaurantCount: 120,
      averageRating: 4.8,
      topCuisines: ["Hyderabadi", "Biryani", "North Indian", "Chinese", "Continental"],
      averageSavings: "₹9,500"
    },
    testimonials: [
      {
        name: "Mohammed Ahmed",
        restaurant: "Paradise Biryani, Secunderabad",
        quote: "BillByteKOT understands our biryani business perfectly. The portion tracking and spice level management is excellent.",
        rating: 5,
        image: "/images/testimonials/mohammed-hyderabad.jpg"
      },
      {
        name: "Ramesh Chandra",
        restaurant: "Hyderabad House, Banjara Hills",
        quote: "Telugu interface made it easy for our staff to adapt. The training was minimal and results were immediate.",
        rating: 5,
        image: "/images/testimonials/ramesh-hyderabad.jpg"
      },
      {
        name: "Fatima Begum",
        restaurant: "Royal Kitchen, HITEC City",
        quote: "Managing our traditional recipes with modern technology. BillByteKOT bridges the gap perfectly.",
        rating: 5,
        image: "/images/testimonials/fatima-hyderabad.jpg"
      }
    ],
    localFeatures: [
      "Telugu language interface for local staff",
      "Specialized biryani and traditional cuisine support",
      "Telangana state GST compliance",
      "Integration with local spice suppliers",
      "Support for traditional Hyderabadi dining customs",
      "Halal certification tracking features",
      "Local festival and event management"
    ],
    nearbyAreas: [
      "Banjara Hills", "Jubilee Hills", "HITEC City", "Gachibowli", "Secunderabad",
      "Kukatpally", "Madhapur", "Kondapur", "Miyapur", "Uppal"
    ],
    popularRestaurantTypes: [
      "Biryani Houses", "Traditional Hyderabadi", "Haleem Centers",
      "Irani Cafes", "Kebab Restaurants", "Sweet Shops"
    ]
  },

  chennai: {
    name: "Chennai",
    state: "Tamil Nadu",
    slug: "restaurant-billing-software-chennai",
    title: "Restaurant Billing Software Chennai 2025 | Tamil Nadu POS",
    description: "Top restaurant billing software Chennai. Tamil interface, South Indian cuisine support, GST compliant. Trusted by 100+ Chennai restaurants.",
    keywords: [
      "restaurant billing software Chennai",
      "restaurant POS Chennai",
      "billing software Tamil Nadu",
      "Chennai restaurant software",
      "POS system Chennai"
    ],
    stats: {
      restaurantCount: 100,
      averageRating: 4.7,
      topCuisines: ["South Indian", "Tamil", "North Indian", "Chinese", "Continental"],
      averageSavings: "₹8,500"
    },
    testimonials: [
      {
        name: "Murugan Selvam",
        restaurant: "Saravana Bhavan, T. Nagar",
        quote: "Tamil interface செய்தது எங்கள் ஊழியர்களுக்கு மிகவும் எளிதாக்கியது. BillByteKOT is perfect for our traditional restaurant.",
        rating: 5,
        image: "/images/testimonials/murugan-chennai.jpg"
      },
      {
        name: "Priya Krishnan",
        restaurant: "Chettinad Spice, Adyar",
        quote: "The spice level tracking and South Indian thali management features are exactly what we needed.",
        rating: 5,
        image: "/images/testimonials/priya-chennai.jpg"
      },
      {
        name: "Rajesh Kumar",
        restaurant: "Marina Meals, Besant Nagar",
        quote: "Coastal location, reliable software. Works perfectly even during Chennai's monsoon season.",
        rating: 5,
        image: "/images/testimonials/rajesh-chennai.jpg"
      }
    ],
    localFeatures: [
      "Tamil language interface and support",
      "South Indian cuisine-specific features",
      "Tamil Nadu state GST compliance",
      "Support for traditional Tamil dining customs",
      "Integration with local suppliers and vendors",
      "Monsoon-resistant offline capabilities",
      "Festival and cultural event management"
    ],
    nearbyAreas: [
      "T. Nagar", "Adyar", "Velachery", "Anna Nagar", "Besant Nagar",
      "Mylapore", "Nungambakkam", "Porur", "Tambaram", "OMR"
    ],
    popularRestaurantTypes: [
      "Traditional Tamil Restaurants", "Chettinad Cuisine", "Tiffin Centers",
      "Filter Coffee Shops", "Seafood Restaurants", "Vegetarian Restaurants"
    ]
  },

  kolkata: {
    name: "Kolkata",
    state: "West Bengal",
    slug: "restaurant-billing-software-kolkata",
    title: "Restaurant Billing Software Kolkata 2025 | Bengali POS System",
    description: "Best restaurant billing software Kolkata. Bengali interface, fish & sweets billing, cultural event support. Perfect for Kolkata's rich culinary heritage.",
    keywords: [
      "restaurant billing software Kolkata",
      "restaurant POS Kolkata",
      "billing software West Bengal",
      "Kolkata restaurant software",
      "Bengali restaurant POS"
    ],
    stats: {
      restaurantCount: 90,
      averageRating: 4.6,
      topCuisines: ["Bengali", "Fish Curry", "Sweets", "North Indian", "Chinese"],
      averageSavings: "₹7,500"
    },
    testimonials: [
      {
        name: "Subhash Ghosh",
        restaurant: "Bhojohori Manna, Salt Lake",
        quote: "আমাদের ঐতিহ্যবাহী বাঙালি খাবারের জন্য perfect! Fish curry থেকে রসগোল্লা - সব কিছুর billing সহজ হয়ে গেছে।",
        rating: 5,
        image: "/images/testimonials/subhash-kolkata.jpg"
      },
      {
        name: "Ruma Chatterjee",
        restaurant: "Sweet Bengal, Park Street",
        quote: "Our sweet shop needed specialized billing for weight-based items. BillByteKOT handles it perfectly!",
        rating: 5,
        image: "/images/testimonials/ruma-kolkata.jpg"
      },
      {
        name: "Amit Banerjee",
        restaurant: "Fish Market Restaurant, Gariahat",
        quote: "Daily fish market price updates integration is brilliant. Saves us hours of manual work.",
        rating: 5,
        image: "/images/testimonials/amit-kolkata.jpg"
      }
    ],
    localFeatures: [
      "Bengali language interface and support",
      "Fish market price integration",
      "Sweet shop weight-based billing",
      "West Bengal GST compliance",
      "Cultural festival menu management",
      "Traditional Bengali dining customs support",
      "Integration with local fish and vegetable markets"
    ],
    nearbyAreas: [
      "Park Street", "Salt Lake", "New Town", "Gariahat", "Ballygunge",
      "Howrah", "Barasat", "Dum Dum", "Jadavpur", "Tollygunge"
    ],
    popularRestaurantTypes: [
      "Traditional Bengali Restaurants", "Fish Curry Houses", "Sweet Shops",
      "Adda Cafes", "Chinese Restaurants", "Street Food Stalls"
    ]
  },

  pune: {
    name: "Pune",
    state: "Maharashtra",
    slug: "restaurant-billing-software-pune",
    title: "Restaurant Billing Software Pune 2025 | Student City POS",
    description: "Top restaurant billing software Pune. Student-friendly pricing, multi-location support, cloud sync. Perfect for Pune's diverse restaurant scene.",
    keywords: [
      "restaurant billing software Pune",
      "restaurant POS Pune",
      "billing software Pune restaurants",
      "Pune restaurant software",
      "POS system Maharashtra"
    ],
    stats: {
      restaurantCount: 85,
      averageRating: 4.7,
      topCuisines: ["Maharashtrian", "North Indian", "South Indian", "Chinese", "Fast Food"],
      averageSavings: "₹8,000"
    },
    testimonials: [
      {
        name: "Sachin Patil",
        restaurant: "Pune Misal, FC Road",
        quote: "Student crowd loves our quick service powered by BillByteKOT. Order processing time reduced by 60%!",
        rating: 5,
        image: "/images/testimonials/sachin-pune.jpg"
      },
      {
        name: "Meera Joshi",
        restaurant: "Koregaon Cafe, Koregaon Park",
        quote: "Managing breakfast rush and late-night orders became effortless. The system adapts to our varied timings perfectly.",
        rating: 5,
        image: "/images/testimonials/meera-pune.jpg"
      },
      {
        name: "Rahul Deshmukh",
        restaurant: "Vada Pav Corner, Shivajinagar",
        quote: "From street food to fine dining - BillByteKOT scales with our business growth beautifully.",
        rating: 5,
        image: "/images/testimonials/rahul-pune.jpg"
      }
    ],
    localFeatures: [
      "Student-friendly quick billing features",
      "Marathi and English language support",
      "Multi-location management for chains",
      "Maharashtra state GST compliance",
      "Integration with college campus delivery",
      "Late-night dining support features",
      "Monsoon-ready offline capabilities"
    ],
    nearbyAreas: [
      "FC Road", "Koregaon Park", "Shivajinagar", "Kothrud", "Wakad",
      "Hinjewadi", "Baner", "Aundh", "Viman Nagar", "Hadapsar"
    ],
    popularRestaurantTypes: [
      "Student Cafeterias", "Misal Pav Centers", "Vada Pav Stalls",
      "IT Park Food Courts", "Traditional Maharashtrian", "Fast Food Chains"
    ]
  },

  ahmedabad: {
    name: "Ahmedabad",
    state: "Gujarat",
    slug: "restaurant-billing-software-ahmedabad",
    title: "Restaurant Billing Software Ahmedabad 2025 | Gujarati POS",
    description: "Best restaurant billing software Ahmedabad. Gujarati interface, thali billing, Jain food support. Trusted by Gujarat's vegetarian restaurants.",
    keywords: [
      "restaurant billing software Ahmedabad",
      "restaurant POS Ahmedabad",
      "billing software Gujarat",
      "Ahmedabad restaurant software",
      "Gujarati restaurant POS"
    ],
    stats: {
      restaurantCount: 75,
      averageRating: 4.8,
      topCuisines: ["Gujarati", "Thali", "Jain Food", "North Indian", "South Indian"],
      averageSavings: "₹7,000"
    },
    testimonials: [
      {
        name: "Kiran Patel",
        restaurant: "Gujarati Thali House, Maninagar",
        quote: "અમારા થાળી બિઝનેસ માટે perfect! Unlimited thali billing અને Jain food options બહુ સરસ છે।",
        rating: 5,
        image: "/images/testimonials/kiran-ahmedabad.jpg"
      },
      {
        name: "Bhavna Shah",
        restaurant: "Rajwadi Restaurant, Satellite",
        quote: "Pure vegetarian restaurant management made easy. The Jain food filtering system is exactly what we needed.",
        rating: 5,
        image: "/images/testimonials/bhavna-ahmedabad.jpg"
      },
      {
        name: "Jayesh Modi",
        restaurant: "Dhokla Express, CG Road",
        quote: "From dhokla to full thali - handles our diverse Gujarati menu perfectly. Customer love the quick service!",
        rating: 5,
        image: "/images/testimonials/jayesh-ahmedabad.jpg"
      }
    ],
    localFeatures: [
      "Gujarati language interface and support",
      "Unlimited thali billing system",
      "Jain food filtering and management",
      "Gujarat state GST compliance",
      "Pure vegetarian restaurant features",
      "Festival and cultural event menus",
      "Integration with local vegetable markets"
    ],
    nearbyAreas: [
      "Satellite", "CG Road", "Maninagar", "Vastrapur", "Bopal",
      "Prahlad Nagar", "Navrangpura", "Ellis Bridge", "Paldi", "Ghatlodia"
    ],
    popularRestaurantTypes: [
      "Gujarati Thali Restaurants", "Jain Food Restaurants", "Dhokla Centers",
      "Farsan Shops", "Pure Vegetarian Restaurants", "Sweet Shops"
    ]
  },

  jaipur: {
    name: "Jaipur",
    state: "Rajasthan",
    slug: "restaurant-billing-software-jaipur",
    title: "Restaurant Billing Software Jaipur 2025 | Pink City POS",
    description: "Top restaurant billing software Jaipur. Rajasthani cuisine support, tourist billing, heritage restaurant features. Perfect for Pink City's royal dining.",
    keywords: [
      "restaurant billing software Jaipur",
      "restaurant POS Jaipur",
      "billing software Rajasthan",
      "Jaipur restaurant software",
      "Pink City restaurant POS"
    ],
    stats: {
      restaurantCount: 65,
      averageRating: 4.6,
      topCuisines: ["Rajasthani", "Dal Baati", "North Indian", "Mughlai", "Continental"],
      averageSavings: "₹6,500"
    },
    testimonials: [
      {
        name: "Maharaj Singh",
        restaurant: "Royal Rajasthani, City Palace Road",
        quote: "हमारे राजस्थानी व्यंजनों के लिए बिल्कुल सही! Tourist billing और multiple currency support बहुत काम आता है।",
        rating: 5,
        image: "/images/testimonials/maharaj-jaipur.jpg"
      },
      {
        name: "Sunita Rathore",
        restaurant: "Heritage Haveli, Hawa Mahal",
        quote: "Managing our heritage restaurant with modern technology. The royal theme customization is beautiful!",
        rating: 5,
        image: "/images/testimonials/sunita-jaipur.jpg"
      },
      {
        name: "Vikram Shekhawat",
        restaurant: "Dal Baati Corner, MI Road",
        quote: "Traditional recipes, modern billing. BillByteKOT respects our culture while improving efficiency.",
        rating: 5,
        image: "/images/testimonials/vikram-jaipur.jpg"
      }
    ],
    localFeatures: [
      "Hindi and Rajasthani language support",
      "Tourist and heritage restaurant billing",
      "Multiple currency support for tourists",
      "Rajasthan state GST compliance",
      "Traditional Rajasthani cuisine management",
      "Royal theme customization options",
      "Integration with tourism booking systems"
    ],
    nearbyAreas: [
      "City Palace Road", "MI Road", "Hawa Mahal", "Amber Road", "C-Scheme",
      "Malviya Nagar", "Vaishali Nagar", "Mansarovar", "Jagatpura", "Sanganer"
    ],
    popularRestaurantTypes: [
      "Heritage Restaurants", "Rajasthani Thali Houses", "Dal Baati Centers",
      "Royal Dining", "Tourist Restaurants", "Traditional Sweet Shops"
    ]
  },

  lucknow: {
    name: "Lucknow",
    state: "Uttar Pradesh",
    slug: "restaurant-billing-software-lucknow",
    title: "Restaurant Billing Software Lucknow 2025 | Nawabi POS System",
    description: "Best restaurant billing software Lucknow. Awadhi cuisine support, kebab billing, Nawabi restaurant features. Perfect for City of Nawabs dining culture.",
    keywords: [
      "restaurant billing software Lucknow",
      "restaurant POS Lucknow",
      "billing software Uttar Pradesh",
      "Lucknow restaurant software",
      "Nawabi restaurant POS"
    ],
    stats: {
      restaurantCount: 55,
      averageRating: 4.5,
      topCuisines: ["Awadhi", "Kebabs", "Biryani", "Mughlai", "North Indian"],
      averageSavings: "₹6,000"
    },
    testimonials: [
      {
        name: "Nawab Ahmed Ali",
        restaurant: "Tunday Kababi, Aminabad",
        quote: "हमारे पारंपरिक कबाब बिजनेस के लिए perfect! Weight-based kebab billing और traditional recipes management excellent है।",
        rating: 5,
        image: "/images/testimonials/nawab-lucknow.jpg"
      },
      {
        name: "Fatima Khan",
        restaurant: "Awadhi Zaika, Hazratganj",
        quote: "The Awadhi cuisine features understand our traditional cooking methods. Dum cooking time tracking is brilliant!",
        rating: 5,
        image: "/images/testimonials/fatima-lucknow.jpg"
      },
      {
        name: "Ravi Srivastava",
        restaurant: "Lucknowi Biryani House, Gomti Nagar",
        quote: "From street-side kebabs to royal biryani - handles our diverse Lucknowi menu with elegance.",
        rating: 5,
        image: "/images/testimonials/ravi-lucknow.jpg"
      }
    ],
    localFeatures: [
      "Hindi and Urdu language support",
      "Awadhi cuisine-specific billing features",
      "Kebab weight-based billing system",
      "Uttar Pradesh state GST compliance",
      "Traditional cooking time tracking",
      "Nawabi restaurant theme options",
      "Integration with local spice markets"
    ],
    nearbyAreas: [
      "Hazratganj", "Aminabad", "Gomti Nagar", "Indira Nagar", "Alambagh",
      "Mahanagar", "Rajajipuram", "Aliganj", "Jankipuram", "Chinhat"
    ],
    popularRestaurantTypes: [
      "Kebab Houses", "Awadhi Restaurants", "Biryani Centers",
      "Traditional Dhabas", "Nawabi Dining", "Street Food Stalls"
    ]
  },

  chandigarh: {
    name: "Chandigarh",
    state: "Punjab/Haryana",
    slug: "restaurant-billing-software-chandigarh",
    title: "Restaurant Billing Software Chandigarh 2025 | City Beautiful POS",
    description: "Top restaurant billing software Chandigarh. Punjabi cuisine support, dhaba billing, multi-state GST. Perfect for City Beautiful's diverse dining scene.",
    keywords: [
      "restaurant billing software Chandigarh",
      "restaurant POS Chandigarh",
      "billing software Punjab Haryana",
      "Chandigarh restaurant software",
      "City Beautiful restaurant POS"
    ],
    stats: {
      restaurantCount: 50,
      averageRating: 4.7,
      topCuisines: ["Punjabi", "North Indian", "Dhaba Style", "Chinese", "Continental"],
      averageSavings: "₹5,500"
    },
    testimonials: [
      {
        name: "Gurpreet Singh",
        restaurant: "Punjabi Dhaba, Sector 17",
        quote: "ਸਾਡੇ ਪੰਜਾਬੀ ਢਾਬੇ ਲਈ ਬਿਲਕੁਲ ਸਹੀ! Lassi से लेकर butter chicken तक - सब कुछ का billing आसान हो गया।",
        rating: 5,
        image: "/images/testimonials/gurpreet-chandigarh.jpg"
      },
      {
        name: "Simran Kaur",
        restaurant: "City Beautiful Cafe, Sector 35",
        quote: "Modern cafe in a planned city needs modern solutions. BillByteKOT's clean interface matches our aesthetic perfectly.",
        rating: 5,
        image: "/images/testimonials/simran-chandigarh.jpg"
      },
      {
        name: "Rajesh Kumar",
        restaurant: "Highway Dhaba, Zirakpur",
        quote: "Highway location, 24/7 operations - BillByteKOT handles our unique requirements flawlessly.",
        rating: 5,
        image: "/images/testimonials/rajesh-chandigarh.jpg"
      }
    ],
    localFeatures: [
      "Punjabi and Hindi language support",
      "Multi-state GST compliance (Punjab/Haryana)",
      "Dhaba-style restaurant billing",
      "Highway restaurant features",
      "24/7 operation support",
      "Planned city delivery integration",
      "Cross-border billing capabilities"
    ],
    nearbyAreas: [
      "Sector 17", "Sector 35", "Zirakpur", "Mohali", "Panchkula",
      "Sector 22", "Sector 26", "Manimajra", "Mullanpur", "Kharar"
    ],
    popularRestaurantTypes: [
      "Punjabi Dhabas", "Highway Restaurants", "Modern Cafes",
      "Sector Markets Food Courts", "Butter Chicken Specialists", "Lassi Shops"
    ]
  },

  kochi: {
    name: "Kochi",
    state: "Kerala",
    slug: "restaurant-billing-software-kochi",
    title: "Restaurant Billing Software Kochi 2025 | Kerala Seafood POS",
    description: "Best restaurant billing software Kochi. Malayalam interface, seafood billing, spice level tracking. Perfect for God's Own Country cuisine.",
    keywords: [
      "restaurant billing software Kochi",
      "restaurant POS Kochi",
      "billing software Kerala",
      "Kochi restaurant software",
      "Kerala seafood restaurant POS"
    ],
    stats: {
      restaurantCount: 45,
      averageRating: 4.6,
      topCuisines: ["Kerala", "Seafood", "South Indian", "North Indian", "Chinese"],
      averageSavings: "₹5,000"
    },
    testimonials: [
      {
        name: "Ravi Menon",
        restaurant: "Kerala Kitchen, Marine Drive",
        quote: "കേരളത്തിന്റെ സ്വന്തം രുചികൾക്ക് perfect billing! Fish curry മുതൽ appam വരെ - എല്ലാം easy ആയി manage ചെയ്യാം।",
        rating: 5,
        image: "/images/testimonials/ravi-kochi.jpg"
      },
      {
        name: "Priya Nair",
        restaurant: "Spice Coast, Fort Kochi",
        quote: "Tourist season billing and local customer management - both handled beautifully by BillByteKOT.",
        rating: 5,
        image: "/images/testimonials/priya-kochi.jpg"
      },
      {
        name: "Suresh Kumar",
        restaurant: "Backwater Seafood, Kumbakonam",
        quote: "Daily fresh fish pricing updates and coconut-based dish management - exactly what our coastal restaurant needed.",
        rating: 5,
        image: "/images/testimonials/suresh-kochi.jpg"
      }
    ],
    localFeatures: [
      "Malayalam language interface and support",
      "Seafood and fish market integration",
      "Spice level and coconut content tracking",
      "Kerala state GST compliance",
      "Tourist season billing management",
      "Backwater restaurant features",
      "Integration with local spice markets"
    ],
    nearbyAreas: [
      "Marine Drive", "Fort Kochi", "Ernakulam", "Kakkanad", "Edapally",
      "Kaloor", "Palarivattom", "Vytilla", "Aluva", "Perumbavoor"
    ],
    popularRestaurantTypes: [
      "Kerala Traditional Restaurants", "Seafood Specialists", "Backwater Dining",
      "Spice Gardens Restaurants", "Tourist Restaurants", "Coconut-based Cuisine"
    ]
  },

  coimbatore: {
    name: "Coimbatore",
    state: "Tamil Nadu",
    slug: "restaurant-billing-software-coimbatore",
    title: "Restaurant Billing Software Coimbatore 2025 | Textile City POS",
    description: "Top restaurant billing software Coimbatore. Tamil interface, South Indian billing, textile industry catering. Perfect for Coimbatore's business dining.",
    keywords: [
      "restaurant billing software Coimbatore",
      "restaurant POS Coimbatore",
      "billing software Coimbatore",
      "textile city restaurant software",
      "Coimbatore restaurant POS"
    ],
    stats: {
      restaurantCount: 40,
      averageRating: 4.5,
      topCuisines: ["South Indian", "Tamil", "North Indian", "Chinese", "Continental"],
      averageSavings: "₹4,500"
    },
    testimonials: [
      {
        name: "Murugan Textiles",
        restaurant: "Kongu Mess, RS Puram",
        quote: "கோயம்புத்தூர் style சாப்பாட்டுக்கு perfect billing! Business lunch மற்றும் family dinner - இரண்டும் சரியாக handle பண்ணுது।",
        rating: 5,
        image: "/images/testimonials/murugan-coimbatore.jpg"
      },
      {
        name: "Lakshmi Sundaram",
        restaurant: "Annapoorna, Gandhipuram",
        quote: "Our vegetarian restaurant serves the textile industry workers. Quick billing during lunch rush is essential - BillByteKOT delivers!",
        rating: 5,
        image: "/images/testimonials/lakshmi-coimbatore.jpg"
      },
      {
        name: "Rajesh Naidu",
        restaurant: "Spice Garden, Peelamedu",
        quote: "IT park location needs modern solutions. The system handles both traditional Tamil food and continental cuisine perfectly.",
        rating: 5,
        image: "/images/testimonials/rajesh-coimbatore.jpg"
      }
    ],
    localFeatures: [
      "Tamil language interface and support",
      "Business lunch rush management",
      "Textile industry catering features",
      "Tamil Nadu state GST compliance",
      "IT park food court integration",
      "Traditional South Indian billing",
      "Multi-shift restaurant support"
    ],
    nearbyAreas: [
      "RS Puram", "Gandhipuram", "Peelamedu", "Saibaba Colony", "Race Course",
      "Singanallur", "Podanur", "Sulur", "Kalapatti", "Thudiyalur"
    ],
    popularRestaurantTypes: [
      "Traditional Mess", "Business Lunch Restaurants", "IT Park Cafeterias",
      "Vegetarian Restaurants", "Textile Worker Canteens", "Family Restaurants"
    ]
  },

  indore: {
    name: "Indore",
    state: "Madhya Pradesh",
    slug: "restaurant-billing-software-indore",
    title: "Restaurant Billing Software Indore 2025 | Food Capital POS",
    description: "Best restaurant billing software Indore. Street food billing, poha-jalebi support, MP GST compliant. Perfect for India's cleanest city dining.",
    keywords: [
      "restaurant billing software Indore",
      "restaurant POS Indore",
      "billing software Madhya Pradesh",
      "Indore street food software",
      "food capital restaurant POS"
    ],
    stats: {
      restaurantCount: 35,
      averageRating: 4.4,
      topCuisines: ["Street Food", "Poha-Jalebi", "North Indian", "South Indian", "Chinese"],
      averageSavings: "₹4,000"
    },
    testimonials: [
      {
        name: "Ramesh Agarwal",
        restaurant: "Indori Poha, Sarafa Bazaar",
        quote: "इंदौर के स्ट्रीट फूड के लिए बिल्कुल सही! Poha-jalebi से लेकर daal-baafla तक - सब कुछ का billing आसान।",
        rating: 5,
        image: "/images/testimonials/ramesh-indore.jpg"
      },
      {
        name: "Sunita Jain",
        restaurant: "Clean Food Corner, Vijay Nagar",
        quote: "Cleanest city deserves cleanest billing! BillByteKOT's hygiene-focused features align with our city's values.",
        rating: 5,
        image: "/images/testimonials/sunita-indore.jpg"
      },
      {
        name: "Vikash Sharma",
        restaurant: "Night Bazaar Treats, Chappan Dukan",
        quote: "Night market operations made easy. The system handles our unique evening-to-midnight business hours perfectly.",
        rating: 5,
        image: "/images/testimonials/vikash-indore.jpg"
      }
    ],
    localFeatures: [
      "Hindi language interface and support",
      "Street food and night market billing",
      "Poha-jalebi specialized features",
      "Madhya Pradesh state GST compliance",
      "Clean city hygiene tracking",
      "Night bazaar operation support",
      "Traditional MP cuisine management"
    ],
    nearbyAreas: [
      "Sarafa Bazaar", "Chappan Dukan", "Vijay Nagar", "Palasia", "Bhawar Kuan",
      "Rajwada", "Khajrana", "Nipania", "Rau", "Dewas Road"
    ],
    popularRestaurantTypes: [
      "Street Food Stalls", "Poha-Jalebi Centers", "Night Markets",
      "Traditional MP Restaurants", "Clean Food Courts", "Namkeen Shops"
    ]
  },

  surat: {
    name: "Surat",
    state: "Gujarat",
    slug: "restaurant-billing-software-surat",
    title: "Restaurant Billing Software Surat 2025 | Diamond City POS",
    description: "Top restaurant billing software Surat. Gujarati interface, diamond merchant dining, textile industry catering. Perfect for Surat's business community.",
    keywords: [
      "restaurant billing software Surat",
      "restaurant POS Surat",
      "billing software Surat Gujarat",
      "diamond city restaurant software",
      "Surat textile restaurant POS"
    ],
    stats: {
      restaurantCount: 40,
      averageRating: 4.6,
      topCuisines: ["Gujarati", "South Indian", "Punjabi", "Chinese", "Fast Food"],
      averageSavings: "₹4,500"
    },
    testimonials: [
      {
        name: "Kiran Patel",
        restaurant: "Diamond Thali, Ring Road",
        quote: "સુરતના ડાયમંડ બિઝનેસ માટે perfect! Business lunch અને family dinner બંને માટે excellent billing system છે।",
        rating: 5,
        image: "/images/testimonials/kiran-surat.jpg"
      },
      {
        name: "Meera Shah",
        restaurant: "Textile Hub Cafe, Varachha",
        quote: "Our cafe serves the textile industry. Quick service during business hours is crucial - BillByteKOT delivers perfectly!",
        rating: 5,
        image: "/images/testimonials/meera-surat.jpg"
      },
      {
        name: "Jayesh Modi",
        restaurant: "Kathiyawadi Dhaba, Udhna",
        quote: "Traditional Gujarati flavors with modern billing. The system respects our culture while improving efficiency.",
        rating: 5,
        image: "/images/testimonials/jayesh-surat.jpg"
      }
    ],
    localFeatures: [
      "Gujarati language interface and support",
      "Diamond merchant dining features",
      "Textile industry business lunch support",
      "Gujarat state GST compliance",
      "Multi-community cuisine management",
      "Business district quick billing",
      "Traditional Gujarati thali billing"
    ],
    nearbyAreas: [
      "Ring Road", "Varachha", "Udhna", "Adajan", "Vesu",
      "Katargam", "Rander", "Sachin", "Kamrej", "Bardoli"
    ],
    popularRestaurantTypes: [
      "Business Lunch Restaurants", "Gujarati Thali Houses", "Textile Hub Cafes",
      "Diamond Merchant Dining", "South Indian Restaurants", "Fast Food Chains"
    ]
  },

  nagpur: {
    name: "Nagpur",
    state: "Maharashtra",
    slug: "restaurant-billing-software-nagpur",
    title: "Restaurant Billing Software Nagpur 2025 | Orange City POS",
    description: "Best restaurant billing software Nagpur. Marathi interface, orange-based dishes, central India cuisine. Perfect for Orange City's unique dining culture.",
    keywords: [
      "restaurant billing software Nagpur",
      "restaurant POS Nagpur",
      "billing software Nagpur Maharashtra",
      "orange city restaurant software",
      "central India restaurant POS"
    ],
    stats: {
      restaurantCount: 30,
      averageRating: 4.3,
      topCuisines: ["Maharashtrian", "Vidarbha", "North Indian", "South Indian", "Chinese"],
      averageSavings: "₹3,500"
    },
    testimonials: [
      {
        name: "Prakash Deshmukh",
        restaurant: "Orange Tadka, Sitabuldi",
        quote: "नागपूरच्या खास पदार्थांसाठी perfect! Orange barfi पासून saoji curry पर्यंत - सगळ्याचं billing सोपं झालं।",
        rating: 5,
        image: "/images/testimonials/prakash-nagpur.jpg"
      },
      {
        name: "Sunita Wankhede",
        restaurant: "Vidarbha Kitchen, Civil Lines",
        quote: "Our traditional Vidarbha cuisine needed specialized billing. BillByteKOT understands our spicy food culture perfectly!",
        rating: 5,
        image: "/images/testimonials/sunita-nagpur.jpg"
      },
      {
        name: "Rajesh Bhoyar",
        restaurant: "Central Plaza Food Court, Dharampeth",
        quote: "Managing multiple vendors in our food court became effortless. The central billing system is brilliant!",
        rating: 5,
        image: "/images/testimonials/rajesh-nagpur.jpg"
      }
    ],
    localFeatures: [
      "Marathi language interface and support",
      "Vidarbha cuisine specialized billing",
      "Orange-based dish management",
      "Maharashtra state GST compliance",
      "Central India spice level tracking",
      "Multi-vendor food court support",
      "Traditional Maharashtrian features"
    ],
    nearbyAreas: [
      "Sitabuldi", "Civil Lines", "Dharampeth", "Sadar", "Hingna",
      "Wadi", "Manish Nagar", "Trimurti Nagar", "Shankar Nagar", "Koradi"
    ],
    popularRestaurantTypes: [
      "Vidarbha Cuisine Restaurants", "Orange Specialty Shops", "Saoji Restaurants",
      "Traditional Maharashtrian", "Central India Food Courts", "Spicy Food Specialists"
    ]
  },

  vizag: {
    name: "Visakhapatnam",
    state: "Andhra Pradesh",
    slug: "restaurant-billing-software-vizag",
    title: "Restaurant Billing Software Vizag 2025 | Port City Seafood POS",
    description: "Top restaurant billing software Visakhapatnam. Telugu interface, seafood billing, Andhra spice levels. Perfect for Vizag's coastal dining scene.",
    keywords: [
      "restaurant billing software Vizag",
      "restaurant POS Visakhapatnam",
      "billing software Andhra Pradesh",
      "Vizag seafood restaurant software",
      "port city restaurant POS"
    ],
    stats: {
      restaurantCount: 25,
      averageRating: 4.4,
      topCuisines: ["Andhra", "Seafood", "South Indian", "North Indian", "Chinese"],
      averageSavings: "₹3,000"
    },
    testimonials: [
      {
        name: "Ravi Prasad",
        restaurant: "Coastal Spice, Beach Road",
        quote: "విజాగ్ seafood కి perfect billing! Fish curry నుండి prawn fry వరకు - అన్నిటికీ సరైన system ఉంది।",
        rating: 5,
        image: "/images/testimonials/ravi-vizag.jpg"
      },
      {
        name: "Lakshmi Devi",
        restaurant: "Andhra Kitchen, MVP Colony",
        quote: "Our spicy Andhra cuisine needs proper spice level tracking. BillByteKOT handles it beautifully!",
        rating: 5,
        image: "/images/testimonials/lakshmi-vizag.jpg"
      },
      {
        name: "Suresh Babu",
        restaurant: "Port View Restaurant, Rushikonda",
        quote: "Beach location, tourist crowd, local seafood - BillByteKOT manages our diverse customer base perfectly.",
        rating: 5,
        image: "/images/testimonials/suresh-vizag.jpg"
      }
    ],
    localFeatures: [
      "Telugu language interface and support",
      "Coastal seafood billing features",
      "Andhra spice level management",
      "Andhra Pradesh state GST compliance",
      "Beach restaurant operations",
      "Tourist and local customer billing",
      "Port city delivery integration"
    ],
    nearbyAreas: [
      "Beach Road", "MVP Colony", "Rushikonda", "Dwaraka Nagar", "Gajuwaka",
      "Madhurawada", "Pendurthi", "Anakapalle", "Bheemunipatnam", "Araku"
    ],
    popularRestaurantTypes: [
      "Seafood Restaurants", "Andhra Cuisine Specialists", "Beach Shacks",
      "Tourist Restaurants", "Port Area Eateries", "Spicy Food Centers"
    ]
  },

  goa: {
    name: "Goa",
    state: "Goa",
    slug: "restaurant-billing-software-goa",
    title: "Restaurant Billing Software Goa 2025 | Beach Paradise POS",
    description: "Best restaurant billing software Goa. Multi-currency support, beach shack billing, tourist management. Perfect for Goa's paradise dining experience.",
    keywords: [
      "restaurant billing software Goa",
      "restaurant POS Goa",
      "beach restaurant billing software",
      "Goa tourist restaurant POS",
      "beach shack billing system"
    ],
    stats: {
      restaurantCount: 50,
      averageRating: 4.7,
      topCuisines: ["Goan", "Seafood", "Portuguese", "North Indian", "Continental"],
      averageSavings: "₹5,500"
    },
    testimonials: [
      {
        name: "Antonio D'Souza",
        restaurant: "Beach Paradise, Calangute",
        quote: "Perfect for our beach shack! Multi-currency billing for tourists and local Konkani interface for staff - brilliant combination!",
        rating: 5,
        image: "/images/testimonials/antonio-goa.jpg"
      },
      {
        name: "Maria Fernandes",
        restaurant: "Portuguese Kitchen, Panaji",
        quote: "Our heritage restaurant needed modern billing. BillByteKOT preserves our Portuguese charm while improving efficiency.",
        rating: 5,
        image: "/images/testimonials/maria-goa.jpg"
      },
      {
        name: "Ravi Naik",
        restaurant: "Sunset Cafe, Anjuna",
        quote: "Beach location, international crowd, local flavors - BillByteKOT handles our unique Goan restaurant perfectly!",
        rating: 5,
        image: "/images/testimonials/ravi-goa.jpg"
      }
    ],
    localFeatures: [
      "Multi-currency billing for tourists",
      "Konkani and English language support",
      "Beach shack and resort integration",
      "Goa state GST compliance",
      "Portuguese cuisine management",
      "Tourist season billing optimization",
      "Beach delivery and service features"
    ],
    nearbyAreas: [
      "Calangute", "Baga", "Anjuna", "Panaji", "Margao",
      "Candolim", "Arambol", "Palolem", "Vasco", "Mapusa"
    ],
    popularRestaurantTypes: [
      "Beach Shacks", "Portuguese Restaurants", "Resort Dining",
      "Tourist Cafes", "Seafood Specialists", "Sunset Restaurants"
    ]
  },

  bhopal: {
    name: "Bhopal",
    state: "Madhya Pradesh",
    slug: "restaurant-billing-software-bhopal",
    title: "Restaurant Billing Software Bhopal 2025 | Lake City POS",
    description: "Top restaurant billing software Bhopal. Hindi interface, Bhopali cuisine, lake-side dining. Perfect for City of Lakes restaurant management.",
    keywords: [
      "restaurant billing software Bhopal",
      "restaurant POS Bhopal",
      "billing software Madhya Pradesh",
      "Bhopal lake restaurant software",
      "city of lakes restaurant POS"
    ],
    stats: {
      restaurantCount: 30,
      averageRating: 4.2,
      topCuisines: ["Bhopali", "North Indian", "Mughlai", "South Indian", "Chinese"],
      averageSavings: "₹3,500"
    },
    testimonials: [
      {
        name: "Salim Khan",
        restaurant: "Lake View Restaurant, Upper Lake",
        quote: "भोपाल के खास व्यंजनों के लिए perfect! Bhopali gosht से लेकर poha तक - सब कुछ का billing आसान हो गया।",
        rating: 5,
        image: "/images/testimonials/salim-bhopal.jpg"
      },
      {
        name: "Rekha Sharma",
        restaurant: "Heritage Kitchen, Old Bhopal",
        quote: "Our traditional restaurant in old city needed modern solutions. BillByteKOT respects our heritage while improving service.",
        rating: 5,
        image: "/images/testimonials/rekha-bhopal.jpg"
      },
      {
        name: "Amit Jain",
        restaurant: "New Bhopal Cafe, Arera Colony",
        quote: "Modern cafe in new Bhopal needs efficient billing. The system handles both traditional and contemporary menu perfectly.",
        rating: 5,
        image: "/images/testimonials/amit-bhopal.jpg"
      }
    ],
    localFeatures: [
      "Hindi language interface and support",
      "Bhopali cuisine specialized features",
      "Lake-side restaurant management",
      "Madhya Pradesh state GST compliance",
      "Heritage and modern restaurant support",
      "Traditional MP cooking methods",
      "Multi-location support for chains"
    ],
    nearbyAreas: [
      "Upper Lake", "Lower Lake", "Arera Colony", "MP Nagar", "Kolar",
      "Shahpura", "Berasia Road", "Raisen Road", "Hoshangabad Road", "Sehore"
    ],
    popularRestaurantTypes: [
      "Lake-side Restaurants", "Heritage Restaurants", "Bhopali Cuisine",
      "Traditional Dhabas", "Modern Cafes", "Mughlai Restaurants"
    ]
  },

  patna: {
    name: "Patna",
    state: "Bihar",
    slug: "restaurant-billing-software-patna",
    title: "Restaurant Billing Software Patna 2025 | Bihar Capital POS",
    description: "Best restaurant billing software Patna. Hindi interface, Bihari cuisine, litti-chokha billing. Perfect for Bihar's capital city dining culture.",
    keywords: [
      "restaurant billing software Patna",
      "restaurant POS Patna",
      "billing software Bihar",
      "Patna restaurant software",
      "Bihari cuisine restaurant POS"
    ],
    stats: {
      restaurantCount: 25,
      averageRating: 4.1,
      topCuisines: ["Bihari", "Litti-Chokha", "North Indian", "Mughlai", "Chinese"],
      averageSavings: "₹3,000"
    },
    testimonials: [
      {
        name: "Ram Prasad Singh",
        restaurant: "Bihar Kitchen, Fraser Road",
        quote: "बिहारी खाने के लिए बिल्कुल सही! Litti-chokha से लेकर sattu paratha तक - सब कुछ का billing perfect है।",
        rating: 5,
        image: "/images/testimonials/ram-patna.jpg"
      },
      {
        name: "Sita Devi",
        restaurant: "Traditional Taste, Boring Road",
        quote: "Our family restaurant serves authentic Bihari food. BillByteKOT understands our traditional recipes and billing needs.",
        rating: 5,
        image: "/images/testimonials/sita-patna.jpg"
      },
      {
        name: "Mukesh Kumar",
        restaurant: "Ganga View Restaurant, Gandhi Maidan",
        quote: "River-side location, traditional food, modern billing - BillByteKOT bridges the gap beautifully!",
        rating: 5,
        image: "/images/testimonials/mukesh-patna.jpg"
      }
    ],
    localFeatures: [
      "Hindi language interface and support",
      "Bihari cuisine specialized billing",
      "Litti-chokha and sattu dish management",
      "Bihar state GST compliance",
      "Traditional cooking method tracking",
      "River-side restaurant features",
      "Cultural festival menu support"
    ],
    nearbyAreas: [
      "Fraser Road", "Boring Road", "Gandhi Maidan", "Kankarbagh", "Rajendra Nagar",
      "Patliputra", "Danapur", "Hajipur", "Muzaffarpur", "Gaya"
    ],
    popularRestaurantTypes: [
      "Traditional Bihari Restaurants", "Litti-Chokha Centers", "River-side Dining",
      "Heritage Restaurants", "Sattu Shops", "Traditional Sweet Shops"
    ]
  }
};

// Export city names array for easy iteration
export const cityNames = Object.keys(cityData);

// Export total count for validation
export const TOTAL_CITIES = cityNames.length;

// Export cities by state for grouping
export const citiesByState = cityNames.reduce((acc, cityKey) => {
  const city = cityData[cityKey];
  if (!acc[city.state]) {
    acc[city.state] = [];
  }
  acc[city.state].push(cityKey);
  return acc;
}, {});

// Export top cities (based on restaurant count)
export const topCities = cityNames
  .sort((a, b) => cityData[b].stats.restaurantCount - cityData[a].stats.restaurantCount)
  .slice(0, 10);

// Export cities with highest ratings
export const topRatedCities = cityNames
  .sort((a, b) => cityData[b].stats.averageRating - cityData[a].stats.averageRating)
  .slice(0, 5);

// Helper function to get city data by slug
export const getCityBySlug = (slug) => {
  return cityNames.find(cityKey => cityData[cityKey].slug === slug);
};

// Helper function to get cities by cuisine type
export const getCitiesByCuisine = (cuisine) => {
  return cityNames.filter(cityKey => 
    cityData[cityKey].stats.topCuisines.includes(cuisine)
  );
};